const ResetPassword = () => {

    return(
        <div></div>
    )
}

export default ResetPassword;